import React from 'react';
import { ClickArea, Container, CrownIcon, DeleteButton, Photo, PhotoArea, Text, TrashIcon } from './styles';

import typ from './index.d';
import { transformarData } from '../../../../utils/convert';

const ConsultantItem: React.FC<typ.Props> = ({ data, handleDelete, handleEdit }) => {

  return (
    <Container key={data.id}>
        <PhotoArea>
            <Photo src={ data.image || require('assets/images/user-temporary.webp') } />
            {data.role === 'admin' && <CrownIcon />}
        </PhotoArea>
        <ClickArea onClick={() => handleEdit?.(data)}>
            <Text style={{ flex: 2.2 }}>
                {data.name}
            </Text>
            <Text style={{ flex: 4 }}>
                {data.email}
            </Text>
            <Text style={{ flex: 2 }}>
                {transformarData(data.created_at)}
            </Text>
        </ClickArea>
        <DeleteButton
            style={{ flex: 0 }}
            onClick={() => handleDelete?.(data)}
        >
            <TrashIcon />
        </DeleteButton>
    </Container>     
  );
};

export default ConsultantItem;
